// https://momentjs.com/docs
import moment from 'moment';

/**
 * Given an ISO string or JS Date object, returns the corresponding time string.
 * @private
 * @param {String|Object} date
 * @return {String}
 */
export default function getTimeString(raw) {
  return moment(raw).format('HH:mm');
}
